import React from 'react'
import PropTypes from 'prop-types'
import MoveToInboxIcon from '@material-ui/icons/MoveToInbox'
import { ListItemIcon } from '@material-ui/core'
import { COLORS } from 'Constants/Theme'

const InboxIcon = ({ style, width = 20, height = 20 }) => (
  <ListItemIcon style={{ color: COLORS.WHITE }}>
    <MoveToInboxIcon style={style} width={width} height={height} />
  </ListItemIcon>
)

InboxIcon.propTypes = {
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default InboxIcon
